import toast from 'react-hot-toast';

import { MessageBlock, MessageBlockContent } from '@cfa/react-components';

import { SuccessToastProps } from '@/types/types';

/**
 * The single message-block surface rendered through the app `<Toaster>`. A
 * toast is a message block with a timeout; a persistent message block (e.g. a
 * LaunchDarkly alert) is the same thing with `duration: Infinity`. Stretches to
 * the Toaster's width so stacked blocks line up.
 */
const ToastMessageBlock: React.FC<SuccessToastProps> = ({
  children,
  id,
  onDismiss,
  severity,
  title,
}) => (
  <MessageBlock
    data-testid="Toast"
    // Lets E2E tell app toasts from LaunchDarkly message blocks (`ld-alert:` ids).
    data-toast-id={id}
    className="w-full max-w-full!"
    onClose={() => {
      onDismiss?.();
      toast.remove(id);
    }}
    severity={severity}
    title={title}
  >
    <MessageBlockContent>{children}</MessageBlockContent>
  </MessageBlock>
);

export default ToastMessageBlock;
